// 手机买菜——美团，主流程
const mtMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `dish/mt/index${i + 1}`,
  name: `dishMtIndex${i + 1}`,
  component: () => import(`@/views/shopping/dish/mt/index${i + 1}.vue`),
}));

//手机买菜--美团，分支
const mtBranchRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `dish/mt/branch/index${i + 1}`,
  name: `dishMtBranchIndex${i + 1}`,
  component: () => import(`@/views/shopping/dish/mt/branch/index${i + 1}.vue`),
}));

// 手机买菜——淘宝，主流程
const tbMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `dish/tb/index${i + 1}`,
  name: `dishTbIndex${i + 1}`,
  component: () => import(`@/views/shopping/dish/tb/index${i + 1}.vue`),
}));

// 手机买菜——淘宝，分支
const tbBranchRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `dish/tb/branch/index${i + 1}`,
  name: `dishTbBranchIndex${i + 1}`,
  component: () => import(`@/views/shopping/dish/tb/branch/index${i + 1}.vue`),
}));

// 手机买菜——拼多多，主流程
const pddMainRoutes = Array.from({ length: 18  }, (_, i) => ({
  path: `dish/pdd/index${i + 1}`,
  name: `dishPddIndex${i + 1}`,
  component: () => import(`@/views/shopping/dish/pdd/index${i + 1}.vue`),
}));

// 手机买菜——拼多多，分支
const pddBranchRoutes = Array.from({ length: 18  }, (_, i) => ({
  path: `dish/pdd/branch/index${i + 1}`,
  name: `dishPddBranchIndex${i + 1}`,
  component: () => import(`@/views/shopping/dish/pdd/branch/index${i + 1}.vue`),
}));

export default {
  path: "/shopping",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    // 手机买菜——美团，主流程
    ...mtMainRoutes,
    ...mtBranchRoutes,

    // 手机买菜——淘宝，主流程
    ...tbMainRoutes,
    ...tbBranchRoutes,

    // 手机买菜——拼多多，主流程
    ...pddMainRoutes,
    ...pddBranchRoutes,
  ],
};
